import { db } from '../firebase'
import _ from 'lodash'

const state = {
  categoryGroups: [],
}

const getters = {
  categoryGroups: state => _.sortBy(state.categoryGroups, 'weight'),
}

const actions = {
  async fetchCategoryGroups(context) {
    const snap = await db.collection('categoryGroups').get()
    const categoryGroups = snap.docs ? _.map(snap.docs, doc => doc.data()) : {}
    context.commit('setCategoryGroups', categoryGroups)
  }
}

const mutations = {
  setCategoryGroups(state, categoryGroups) {
    state.categoryGroups = categoryGroups
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
